import { useState } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Snackbar from "@mui/material/Snackbar";
import Sales from "../components/Sales";

export default function SalesPage() {
  const [snackbarOpen, setSnackbarOpen] = useState<boolean>(false);
  const [triggerFetch] = useState<number>(0);

  return (
    <Box sx={{ padding: "8px 0" }}>
      <Box display="flex" alignItems="center" mb={2}>
        <Typography variant="h6" mr={1}>
          การขาย
        </Typography>
      </Box>
      <Sales triggerFetch={triggerFetch} />
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={1500}
        onClose={() => setSnackbarOpen(false)}
        message="อัพเดทข้อมูลข้อมูลสำเร็จ"
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      />
    </Box>
  );
}
